import { FC } from 'react';
import SearchFormItem from './subpage/searchFormItem';
import SuperUpload from '../SuperUpload';
import { UploadFileProps } from '../SuperUpload/uploadFile';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormUploadProps extends BaseSearchFormItemProps {
  uploadProps?: UploadFileProps;
}
/** 上传 */
export const SearchFormUpload: FC<SearchFormUploadProps> = props => {
  const { uploadProps, name, isDetail, form, testId, ...resProps } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SearchFormItem
      name={name}
      form={form}
      {...resProps}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      test-id={`${testId}-${name}`}
    >
      <SuperUpload.File disabled={isDetail} {...uploadProps} />
    </SearchFormItem>
  );
};

SearchFormUpload.displayName = SearchFormItemEnum.SearchFormUpload;

export default SearchFormUpload;
